/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_codon_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What does frequency per 1000 mean?`)
};

const es_codon_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué significa la frecuencia por 1000?`)
};

const de_codon_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was bedeutet Häufigkeit pro 1000?`)
};

const nl_codon_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat betekent frequentie per 1000?`)
};

const fr_codon_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que signifie la fréquence pour 1000 ?`)
};

const it_codon_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa significa frequenza per 1000?`)
};

const pt_br2_codon_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que significa frequência por 1000?`)
};

const pt_codon_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que significa frequência por 1000?`)
};

const ja_codon_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000あたりの頻度とは何を意味しますか？`)
};

const zh_codon_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每千个的频率是什么意思？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const codon_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.codon_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("codon_faq_q2", locale)
	if (locale === "en") return en_codon_faq_q2(inputs)
	if (locale === "es") return es_codon_faq_q2(inputs)
	if (locale === "de") return de_codon_faq_q2(inputs)
	if (locale === "nl") return nl_codon_faq_q2(inputs)
	if (locale === "fr") return fr_codon_faq_q2(inputs)
	if (locale === "it") return it_codon_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_codon_faq_q2(inputs)
	if (locale === "pt") return pt_codon_faq_q2(inputs)
	if (locale === "ja") return ja_codon_faq_q2(inputs)
	return zh_codon_faq_q2(inputs)
};